import {
  FormGroup,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from '@mui/material';
import { TooltipMain } from 'components/tooltips/tooltipsMain';
import React from 'react';
import NumberFormat from 'react-number-format';

function PondInfoOne(props) {
  const { formik } = props;
  // Nome, area, tipo
  return (
    <Grid item xs={12}>
      <Typography
        style={{
          fontWeight: '700',
          fontSize: '32px',
          textAlign: 'left',
          position: 'absolute',
        }}
      >
        Dados do Viveiro
      </Typography>
      <FormGroup
        style={{ width: '100%', marginTop: '7rem', position: 'relative' }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Nome do viveiro"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              name="description"
              type="text"
              value={formik.values.description}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.description && formik.errors.description}
              helperText={
                formik.touched.description && formik.errors.description
              }
            />
          </Grid>
          <Grid item xs={12}>
            <FormGroup>
              <NumberFormat
                InputLabelProps={{
                  style: { pointerEvents: 'auto' },
                  shrink: true,
                }}
                id="capacity"
                label="Área (m²)"
                variant="outlined"
                name="capacity"
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                value={formik.values.capacity}
                onValueChange={(values) => {
                  formik.setValues({
                    ...formik.values,
                    capacity: values.floatValue,
                  });
                }}
                onBlur={formik.handleBlur}
                customInput={TextField}
                error={!!(formik.touched.capacity && formik.errors.capacity)}
                helperText={formik.touched.capacity && formik.errors.capacity}
              />
            </FormGroup>
          </Grid>
          <Grid item xs={12}>
            <FormGroup>
              <TextField
                InputLabelProps={{
                  style: { pointerEvents: 'auto' },
                  shrink: true,
                }}
                id="type"
                select
                label={(
                  <div>
                    Tipo
                    {' '}
                    <TooltipMain
                      message="Escolha o tipo de viveiro que se adéqua ao que está sendo criado"
                    />
                  </div>
                )}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                variant="outlined"
                value={formik.values.type}
                name="type"
                // as="select"
                error={formik.touched.type && formik.errors.type}
                helperText={formik.touched.type && formik.errors.type}
              >
                <MenuItem key={1} value="Pré-Berçário">
                  Pré-Berçário
                </MenuItem>
                <MenuItem key={2} value="Berçário">
                  Berçário
                </MenuItem>
                <MenuItem key={3} value="Engorda">
                  Engorda
                </MenuItem>
                <MenuItem key={4} value="Outro">
                  Tanque rede
                </MenuItem>
              </TextField>
            </FormGroup>
          </Grid>
        </Grid>
      </FormGroup>
    </Grid>
  );
}

function PondInfoTwo(props) {
  const { formik } = props;
  // Nome, area, tipo
  return (
    <Grid item xs={12}>
      <Typography
        style={{
          fontWeight: '700',
          fontSize: '32px',
          textAlign: 'left',
          position: 'absolute',
        }}
      >
        Dados do Viveiro
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormGroup
            style={{ width: '100%', marginTop: '7rem', position: 'relative' }}
          >
            <TextField
              InputLabelProps={{
                style: { pointerEvents: 'auto', shrink: true },
              }}
              id="system"
              select
              label={(
                <div>
                  Sistema de produção
                  {' '}
                  <TooltipMain
                    message="Tipo de sistema de produção utilizado"
                  />
                </div>
              )}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              variant="outlined"
              value={formik.values.system}
              name="system"
              // as="select"
              error={formik.touched.system && formik.errors.system}
              helperText={formik.touched.system && formik.errors.system}
            >
              <MenuItem key={1} value="Semi-Extensivo">
                Semi-Extensivo
              </MenuItem>
              <MenuItem key={2} value="Extensivo">
                Extensivo
              </MenuItem>
              <MenuItem key={3} value="Semi-Intensivo">
                Semi-Intensivo
              </MenuItem>
              <MenuItem key={4} value="Intensivo">
                Intensivo
              </MenuItem>
              <MenuItem key={5} value="Superintensivo">
                Superintensivo
              </MenuItem>
            </TextField>
          </FormGroup>
        </Grid>
        <Grid item xs={12}>
          <FormGroup>
            <TextField
              InputLabelProps={{
                style: { pointerEvents: 'auto', shrink: true },
              }}
              id="status"
              select
              label="Status do viveiro"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              variant="outlined"
              value={formik.values.status}
              name="status"
              // as="select"
              error={!!(formik.touched.status && formik.errors.status)}
              helperText={
                formik.touched.status
                && formik.errors.status
                && formik.errors.status
              }
            >
              <MenuItem key={2} value="ativo">
                Ativo
              </MenuItem>
              <MenuItem key={3} value="inativo">
                Inativo
              </MenuItem>
            </TextField>
          </FormGroup>
        </Grid>
        <Grid item xs={12}>
          <FormGroup>
            <TextField
              InputLabelProps={{
                style: { pointerEvents: 'auto', shrink: true },
              }}
              id="protocol"
              select
              label={(
                <div>
                  Protocolo de trabalho
                  {' '}
                  <TooltipMain
                    message="Protocolo usado no sistema de produção (Opcional)"
                  />
                </div>
              )}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              variant="outlined"
              value={formik.values.protocol}
              name="protocol"
              // as="select"
              error={formik.touched.protocol && formik.errors.protocol}
              helperText={formik.touched.protocol && formik.errors.protocol}
            >
              <MenuItem key={1} value="Bioflocos">
                Bioflocos
              </MenuItem>
              <MenuItem key={2} value="Heterotróficos">
                Heterotróficos
              </MenuItem>
              <MenuItem key={3} value="Simbióticos">
                Simbióticos
              </MenuItem>
              <MenuItem key={4} value="Convencional">
                Convencional
              </MenuItem>
              <MenuItem key={5} value="Outro">
                Outro
              </MenuItem>
            </TextField>
          </FormGroup>
        </Grid>
      </Grid>
    </Grid>
  );
}

export { PondInfoOne, PondInfoTwo };
